<template>
<div class="container-fluid">


<div class="card border-primary" >
  <div class="card-header text-white bg-primary" >
    <h4>
      <i style="color:yellow" class="fa fa-edit mr-2" aria-hidden="true"></i>
      REGISTRAZIONE/MODIFICA ORDINE FORNITORE
    </h4>
    </div>
  <div class="card-body">
  
      <div v-if="contentType=='A'">

        <button  @click="order={},setNewOrder(),contentType='B'" type="button"  class="btn  btn-success mb-1 ">
        <i style="color:yellow" class="fas fa-edit mr-2" aria-hidden="true"></i>
          NUOVO ORDINE  
        </button>       

        <supplier-orders  v-bind:edit="true"  @update="setOrderData"></supplier-orders>
        
      </div>

      <!-- NEW ORDER  -->
      <div v-else-if="contentType == 'B'">
        <order-header @close="contentType = 'A'" v-bind:_order="order" v-bind:type="'A'"  @update="setOrderData"/>          
      </div>


      <div v-else-if="contentType == 'C'">
        <order-info :key="orderInfoKey" v-bind:orderId="order.orderId"></order-info>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
          <li @click="contentType='A'" class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            RICERCA ORDINE</a></li>
          <li @click="contentType = 'F'" class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="far fa-eye mr-2" aria-hidden="true"></i>
            MOSTRA LISTA PRODOTTI ORDINE</a></li>
          
          </ol>
        </nav>
        
        <!-- NEW PRODUCT ON ORDER -->
        <div  class="card border-info mt-1 ml-1 mr-1 mb-1 border-warning shadow">
          <h4 class="card-header border-warning">
            <i class="far fa-edit mr-2" aria-hidden="true"></i>
            <strong style="color:brown">REGISTRAZIONE ANAGRAFICA PRODOTTO </strong></h4>
          <div class="card-body">
            <product-master :key="productKey"  @update="setProductStock" v-bind:orderId="order.orderId"  v-bind:supplierId="supplierId" v-bind:_product="product"/>
          </div>
        </div>


      </div>

      <!-- PRODUCT STOCK ON ORDER -->
      <div v-else-if = "contentType == 'D'">
        <order-info v-bind:orderId="order.orderId"></order-info>
        <product-qty-detail @back="setProductForm()" @update="setProductPriceDetail" v-bind:product="product"></product-qty-detail>  
      </div>

      <div v-else-if = "contentType == 'E'">

        <div v-if="UpdateBarcodesSupplier">
          <cancel-btn  @click="setStuff()" v-bind:text="'RITORNA A REGISTRAZIONE ORDINE'" class="mb-1 "></cancel-btn>
          <span style="color:blue">ASSOCIAZIONE EAN FORNITORE</span>
          <supplierBarcodes v-bind:item="product" ></supplierBarcodes>
        </div>
        <div v-else>        
        <order-info v-bind:orderId="order.orderId"></order-info>        
        <product-price-detail @update="openConfirmBox" v-bind:product="product" ></product-price-detail>

        <confirm-box v-if="cb.show">
          <template v-slot:header>
            <h4><strong>CONFERMA ORDINE PRODOTTO</strong></h4>    
          </template>
          <template v-slot:body>
              <h4>Procedo ?</h4> 
            </template>
          <template v-slot:footer>  
              <button @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
              <button :disabled="bt_spinner" @click="saveData()" type="button" class="btn btn-primary">SI
                <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
              </button>
          </template>    
        </confirm-box>          
        <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg" ></alert-box> 
        </div>

      </div>

      <div v-else-if = "contentType == 'F'">

        <order-info  v-bind:orderId="order.orderId"></order-info>  
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
          <li @click="setProductFormFromUpdateOrder()"  class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-edit mr-2" aria-hidden="true"></i>
            REGISTRAZIONE PRODOTTO</a></li>
          
          </ol>
        </nav>

        <products-list @update="updateProduct" @change="type=false" :key="productsKey" v-bind:orderId="order.orderId"></products-list>

      </div>
      <div v-else-if = "contentType == 'G'">

      <order-info  v-bind:orderId="order.orderId"></order-info>  
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
        <li @click="contentType='F'"  class="breadcrumb-item"><a href="#">
          <i style="color:rgb(18, 50, 228)" class="fas fa-eye mr-2" aria-hidden="true"></i>
          MOSTRA LISTA PRODOTTI</a></li>        
        </ol>
      </nav>

            <h4 style="color:black">MODIFICA QUANTITA' VARIANTI PRODOTTO ORDINE  </h4>
            <product-info v-bind:productId="product.productId"></product-info>                         
            <product-qty-update @update="setUpdateProductPriceDetail"  v-bind:productId="product.productId" v-bind:order="order" ></product-qty-update>         
            

      </div>
      <div v-else-if = "contentType == 'H'">

          <order-info  v-bind:orderId="order.orderId"></order-info>  
          <nav v-if="1==0" aria-label="breadcrumb">
            <ol class="breadcrumb">
            <li @click="contentType='F'"  class="breadcrumb-item"><a href="#">
              <i style="color:rgb(18, 50, 228)" class="fas fa-eye mr-2" aria-hidden="true"></i>
              MOSTRA LISTA PRODOTTI</a></li>

            
            </ol>
          </nav>
          <h4 style="color:black">MODIFICA PREZZO DI ACQUISTO/SCONTO VARIANTI PRODOTTO ORDINE </h4>
          <product-info v-bind:productId="product.productId"></product-info>                         
          <product-price-update @update="HouseKeeping()" v-bind:productId="product.productId" v-bind:orderId="order.orderId" ></product-price-update>                         
                
      </div>

  </div>
 
</div>
  
<!-- MAIN DIV -->
</div>

</template>
<script>




import api                 from '@/api'
import alertBox            from '@/components/common/AlertBox.vue'
import orderHeader         from '@/components/order/OrderHeader.vue'
import productMaster       from '@/components/order/ProductMaster.vue'
import productQtyDetail    from '@/components/order/ProductQtyDetail.vue'
import productPriceDetail  from '@/components/order/ProductPriceDetail.vue'
import orderInfo           from '@/components/order/OrderInfo.vue'
import productsList        from '@/components/order/OrderProducts.vue'
import supplierOrders      from '@/components/order/SupplierOrders.vue'
import confirmBox          from '@/components/common/ConfirmBox.vue'
import supplierList        from '@/components/supplier/SupplierList.vue'
import pushState           from '@/components/mixins/pushState.js'
import productQtyUpdate    from '@/components/order/ProductQtyUpdate.vue'
import productPriceUpdate  from '@/components/order/ProductPriceDetailUpdate.vue'
import productInfo         from '@/components/product/ProductInfo.vue'
import supplierBarcodes    from '@/components/backOffice/ready/tab/SupplierBarcodes.vue'

import cancelBtn           from '@/components/common/CancelBtn.vue'
export default {
  mixins:[pushState],
  components: {orderHeader,productMaster,productQtyDetail,productPriceDetail,orderInfo,productsList,supplierOrders,confirmBox,alertBox,supplierList,productQtyUpdate,productPriceUpdate,productInfo,supplierBarcodes,cancelBtn},  
 
  data () {
    return {
    
      
      UpdateBarcodesSupplier : false,
      contentType   : 'A',
      supplierId    : 0,  
      type          : true,


      product      : {'productId':0,'barcodes':[],'counter':0,'sizes':[]},
      productKey   : 0,
      productsKey  : 0,
      order        : {},
      orderInfoKey : 0,
      msg          : {
        title : ''
      },
      cb           : {
        show : false
      }, 

      items        : [],
      
      
      bt_spinner   : false


  }
  },

computed: 
{},
mounted()
{},
created()
{},

methods: 
{
  setStuff()
  {
    this.UpdateBarcodesSupplier = false
    this.setNewProduct()
    this.contentType = 'C'
    this.orderInfoKey++
    this.productsKey++
    this.$store.commit('AUTH_LOGOUT_BTN',0)          
  },
  setNewProduct()
  {
    this.product.productId = 0
    this.contentType = 'C'
  },
  HouseKeeping()
  {
    this.$store.commit('AUTH_LOGOUT_BTN',false)
    this.contentType = 'F'
  },
  updateProduct(productId)
  {
    
    this.product.productId = productId
    this.contentType = 'G'
  },
  setUpdateProductPriceDetail(productQty)
  {
    
    if(productQty > 0 )
    {
    
      this.$store.commit('AUTH_LOGOUT_BTN',true)
      this.contentType = 'H'
     
      return
    }

    this.contentType = 'F'
  },
  setProductForm()
  {
    
    this.$store.commit('AUTH_LOGOUT_BTN',0)
    this.contentType = 'C'
  },
  setProductFormFromUpdateOrder()
  {
    this.product.productId = 0
    this.$store.commit('AUTH_LOGOUT_BTN',0)
    this.contentType = 'C'
  },
  setOrderData(data)
  { 
    this.order = data
    this.supplierId = data.supplierId
    this.contentType = 'C'
  },
  setProductStock(data)  
  { 
    

    this.product = data
    this.$store.commit('AUTH_LOGOUT_BTN',1)
    this.contentType = 'D'

  },
  
  setProductPriceDetail(barcodes,sizes,counter)
  {
    this.product.barcodes = barcodes
    this.product.sizes = sizes
    this.product.counter = counter
    this.contentType = 'E'
  },

  openConfirmBox(items)
  {
    
    
    this.items = items
    this.cb.show = true
    
  },
  saveData()
  {
    this.submit(this.items)    
  },
  setNewProduct()
  {
   

    this.product.productId  = 0
    this.product.sku        = ''
    this.product.supplierId = this.supplierId
    this.product.barcodes   = []
    this.product.counter    = 0
   

  },
  setNewOrder()
  {
    this.product = {}
    this.setNewProduct()
  },
  
  async submit(barcodes) 
  {
    this.bt_spinner = true
    var data  = {'orderId' : this.order.orderId,'productId' : this.product.productId, 'counter' : this.product.counter,'items' : barcodes}       
    var sp   = {'sp':'spCreateSupplierOrderDetail'}
    var json = Object.assign(data, sp);
    
    await api.post(json).then(res => {
      if(res.status==200)
        {
          this.UpdateBarcodesSupplier = true
          
        }
        else if(res.status==500)
        {
         
          this.msg.title = 'ATTENZIONE '  
          this.msg.body = res.data 
          this.msg.type = 1         

        } 
        else
        {
         
          this.msg.title = 'ATTENZIONE '  
          this.msg.body = res.data 
          this.msg.type = 1         
                
        } 
    }).catch(err => 
    {
      
          //console.log(err)  
          this.msg.title = 'ATTENZIONE '  
          this.msg.body = err.message
          this.msg.type = 1         
    
    }).finally(() => {
      this.bt_spinner = false
      this.cb.show = false
    });
    



	}
  
      
}
    
}    
</script>

<style scoped>

.bold {
  font-weight: bolder;
}

h4,span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.header_1 {
  background-color:burlywood;
}

.btn-info{
  background-color: darkcyan;
  color : white;
}
.btn-info i{
  color : white !important;
}

.card-header
{
  height: 45px;
}

</style>